module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_EINZELNEPRODUKTE.6ac39058.png";